(() => {
  if (window.__okendoProductRatingInit) return;
  window.__okendoProductRatingInit = true;

  const STAR_PATH = 'm6.5 0 1.607 4.623 4.893.1-3.9 2.956 1.417 4.685L6.5 9.568l-4.017 2.796L3.9 7.679 0 4.723l4.893-.1L6.5 0Z';

  const svgStar = (opacity) => {
    const ns = 'http://www.w3.org/2000/svg';
    const svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    svg.setAttribute('width', '13');
    svg.setAttribute('viewBox', '0 0 13 13');
    const path = document.createElementNS(ns, 'path');
    path.setAttribute('fill', 'currentColor');
    path.setAttribute('fill-opacity', opacity);
    path.setAttribute('d', STAR_PATH);
    svg.appendChild(path);
    return svg;
  };

  const buildStars = (value) => {
    const stars = document.createElement('span');
    stars.className = 'okendo-product-rating__stars';
    const rounded = Math.round(value * 2) / 2;

    for (let i = 1; i <= 5; i += 1) {
      let opacity = '0.3';
      if (rounded >= i) opacity = '1';
      else if (rounded >= i - 0.5) opacity = '0.65';
      stars.appendChild(svgStar(opacity));
    }

    return stars;
  };

  const PRODUCT_TYPES = ['Product', 'ProductGroup'];

  const isProductNode = (node) => {
    if (!node || typeof node !== 'object') return false;
    const type = node['@type'];
    return Array.isArray(type)
      ? type.some((entry) => PRODUCT_TYPES.includes(entry))
      : PRODUCT_TYPES.includes(type);
  };

  const parseRating = (rating) => {
    if (!rating || typeof rating !== 'object') return null;

    const value = parseFloat(rating.ratingValue);
    const count = parseInt(rating.ratingCount, 10);
    if (!value || !count) return null;

    return { value, count };
  };

  const ratingFromNode = (node) => {
    if (!node || typeof node !== 'object') return null;

    if (isProductNode(node)) {
      const rating = parseRating(node.aggregateRating);
      if (rating) return rating;
    }

    const nested = node['@graph'] || node.hasVariant;
    if (Array.isArray(nested)) {
      for (const child of nested) {
        const found = ratingFromNode(child);
        if (found) return found;
      }
    }

    return null;
  };

  const findAggregateRating = () => {
    const scripts = document.querySelectorAll('script[type="application/ld+json"]');
    for (const script of scripts) {
      let data;
      try {
        data = JSON.parse(script.textContent);
      } catch (error) {
        continue;
      }

      const nodes = Array.isArray(data) ? data : [data];
      for (const node of nodes) {
        const found = ratingFromNode(node);
        if (found) return found;
      }
    }
    return null;
  };

  const jumpToReviews = () => {
    const widget = document.querySelector('[data-oke-widget]');
    if (!widget) return;
    const details = widget.closest('details');
    if (details) details.open = true;
    widget.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const activate = (root) => {
    if (root.dataset.okeRatingReady) return;
    root.dataset.okeRatingReady = 'true';

    const rating = findAggregateRating();
    if (!rating) return;

    const { value, count } = rating;

    if (root.dataset.okeFormat === 'text') {
      root.textContent = `Average score: ${value.toFixed(1)}`;
      root.hidden = false;
      return;
    }

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'okendo-product-rating';
    button.appendChild(buildStars(value));

    const countEl = document.createElement('span');
    countEl.className = 'okendo-product-rating__count';
    countEl.textContent = `(${count})`;
    button.appendChild(countEl);

    button.addEventListener('click', jumpToReviews);

    root.replaceChildren(button);
    root.hidden = false;
  };

  const scan = () => {
    document.querySelectorAll('[data-oke-product-rating]').forEach(activate);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', scan);
})();
